module.exports = __webpack_public_path__ + "img/PL.f008702c.webp";